import { useState } from "react";
import {
  Grid,
  Paper,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Divider,
} from "@mui/material";

import PageLayout from "components/layout/PageLayout";
import HistoryList from "components/History/HistoryList";
import HistoryListTransfer from "components/History/HistoryListTransfer";

export default function HistoryPage() {
  const [viewMode, setViewMode] = useState<"detalle" | "resumido">("detalle");

  return (
    <PageLayout
      pageTitle="Historial"
      pageDesc="Historial de movimiento por Ubicaciones o Artículos"
    >
      <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Visualización de Historial</Typography>

          <FormControl component="fieldset">
            <RadioGroup
              row
              value={viewMode}
              onChange={(e) => setViewMode(e.target.value as "detalle" | "resumido")}
            >
              <FormControlLabel
                value="detalle"
                control={<Radio color="primary" />}
                label="Movimientos de stock de los Art. según ubicaciones."
              />
              <FormControlLabel
                value="resumido"
                control={<Radio color="primary" />}
                label="Movimientos de las ubicaciones según Art."
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Paper>

      <Divider sx={{ mb: 3 }} />

      {viewMode === "detalle" ? (
        <HistoryList viewMode={viewMode} />
      ) : (
        <HistoryListTransfer viewMode={viewMode} />
      )}

    </PageLayout>
  );
}
